import httpService from "./http"
import { ApiSearchTypeEnum, ApiQueryOrderByEnum, ApiQueryTargetTypeEnum } from "@/enums/api";

// member
export const getloginInfo = () => httpService.get("MemberAPI/v2/LoginInfo"); //依 rl-topnav
export const postLogout = () => httpService.post("MemberAPI/Logout"); //依 rl-topnav

// banner
export const getBannerV3 = params => httpService.get("RLResource/v3/Banner", { params });

// query
export const postQuery = (params) => httpService.post("LearningCenter/v1/Query", { data: {
    urlName: "",
    productFamily: "",
    level: "",
    productVersion: "",
    keyword: "",
    orderBy: ApiQueryOrderByEnum.BACKEND_SORT,
    searchType: ApiSearchTypeEnum.GROUP_AND_LINK,
    targetType: ApiQueryTargetTypeEnum.ALL,
    ...params
}});
export const getAutoCompleteData = params => httpService.get("LearningCenter/KeywordSuggestion", { params })
export const getProductFamily = () => httpService.get("LearningCenter/ProductFamily");

// detail
export const getVideoDetail = (path, params = {}) => httpService.post('LearningCenter/' + path, { data: params });

// webinar and webinar detail
export const postWebinar = (params) => httpService.post("LearningCenter/v1/Webinar", { data: params });
export const postWebinarDetail = (params) => httpService.post("LearningCenter/v1/Webinar/Detail ", { data: params });

// bookmark
export const postBookmarkQuery = (params) => httpService.post("LearningCenter/v1/Bookmark/Query", { data: params });
export const postBookmarkUpdateStatus = (params) => httpService.post("LearningCenter/v1/Bookmark/UpdateStatus", { data: params });

// Instructors
export const getInstructors = (urlName) => httpService.get("LearningCenter/Instructors/" + urlName);

// History
export const postAddHistory = (params) => httpService.post("LearningCenter/v1/History/Add", { data: params });
export const postHistoryQuery = (params) => httpService.post("LearningCenter/v1/History/Query", { data: params });
export const postClearHistory = (params) => httpService.post("LearningCenter/v1/History/Clear", { data: params });

// Skill path
export const postSkillPathQuery = (params) => httpService.post("LearningCenter/v1/SkillPathQuery", { data: params });